export default {
  title: "Well Done, All is Set-up",
  subtitle: "You are now ready to explore your dashboard!",
  goToDashboard: "Go to Koinz Dashboard",
};
